// extracted by mini-css-extract-plugin
module.exports = {"withdrawals":"styles_withdrawals__3mhhD","heading":"styles_heading__2r_Fl","title":"styles_title__a7gIQ","body":"styles_body__2bDFr"};